<template>
  <div class="col-12 col-md-8 offset-md-2">
    <div class="mb-3">
      <div class="form-check form-switch">
        <input
          type="checkbox"
          class="form-check-input"
          id="is_free"
          v-model="course.is_free"
        />
        <label class="form-check-label" for="is_free">{{'This course is free to watch' | translate}}</label>
      </div>
      <InputErrors :errors="errors" name="is_free"></InputErrors>
    </div>

    <div class="mb-3" v-if="course.is_free">
      <div class="form-check form-switch">
        <input
          type="checkbox"
          class="form-check-input"
          id="requires_login"
          v-model="course.requires_login"
        />
        <label class="form-check-label" for="requires_login"
          >{{'Requires login to watch for free' | translate}}</label
        >
      </div>
      <InputErrors :errors="errors" name="requires_login"></InputErrors>
    </div>

    <div v-if="!course.is_free">
      <label for="price">{{'Price' | translate}}</label>
      <div class="input-group mb-3">
        <input
          type="number"
          id="price"
          class="form-control text-end"
          aria-label="Amount (to the nearest dollar)"
          v-model="course.price"
        />
        <div class="input-group-append">
          <span class="input-group-text">.00</span>
        </div>
      </div>
      <InputErrors :errors="errors" name="price"></InputErrors>

      <div class="mb-3">
        <div class="form-check form-switch">
          <input
            type="checkbox"
            class="form-check-input"
            id="has_promo"
            v-model="course.has_promo"
          />
          <label class="form-check-label" for="has_promo">{{'Has promotion' | translate}}</label>
        </div>
      </div>
      
      <div class="mb-3">
        <div class="form-check form-switch">
          <input
            type="checkbox"
            class="form-check-input"
            id="multiple_licences"
            v-model="course.multiple_licences"
          />
          <label class="form-check-label" for="multiple_licences">{{'Multiple licences' | translate}}</label>
        </div>
      </div>
    </div>

    <div class="mb-3" v-if="course.multiple_licences">
      <ul class="list-group">
        <li class="list-group-item d-flex" v-for="priceItem in course.price_list" :key="priceItem.id">
          <input type="number" class="form-control" v-model="priceItem.activatesAfter">
          <input type="number" class="form-control" v-model="priceItem.value">
        </li>
        <li class="list-group-item" @click="addNewPriceItem">Add</li>
      </ul>
    </div>
    <InputErrors :errors="errors" name="price_list"></InputErrors>

    <div class="" v-if="!course.is_free && course.has_promo">
      <label for="promo_price">{{'Promo price' | translate}}</label>
      <div class="input-group mb-3">
        <input
          type="number"
          class="form-control text-end"
          aria-label="Amount (to the nearest dollar)"
          v-model="course.promo_price"
        />
        <div class="input-group-append">
          <span class="input-group-text">.00</span>
        </div>
      </div>
      <InputErrors :errors="errors" name="promo_price"></InputErrors>


      <div class="mb-3">
        <label for="promo_start">{{'Promo start' | translate}}</label>
        <input
          type="date"
          class="form-control"
          id="promo_start"
          :min="today"
          v-model="course.promo_start"
        />
        <InputErrors :errors="errors" name="promo_start"></InputErrors>
      </div>

      <div class="mb-3">
        <label for="promo_end">{{'Promo ends' | translate}}</label>
        <input
          type="date"
          :min="today"
          class="form-control"
          id="promo_end"
          v-model="course.promo_end"
        />
        
        <InputErrors :errors="errors" name="promo_end"></InputErrors>

        <small
          v-if="dateConflict(course.promo_start, course.promo_end)"
          class="form-text text-danger"
          >{{'End date is before the start date' | translate}}</small
        >
      </div>

      <div class="mb-3">
        <label for="promo_limit">{{'Promo limit' | translate}}</label>
        <input
          type="number"
          min="-2"
          class="form-control"
          id="promo_limit"
          v-model="course.promo_limit"
        />
        <small class="form-text text-muted">
          {{'-1 = infinite number of promo packages' | translate}}
        </small>
        <InputErrors :errors="errors" name="promo_limit"></InputErrors>
      </div>
    </div>

    <input type="hidden" name="is_free" :value="computedCoursePrice.is_free" />
    <input
      type="hidden"
      name="requires_login"
      :value="computedCoursePrice.requires_login"
    />
    <input type="hidden" name="price" :value="computedCoursePrice.price" />
    <input
      type="hidden"
      name="promo_price"
      :value="computedCoursePrice.promo_price"
    />
    <input
      type="hidden"
      name="has_promo"
      :value="computedCoursePrice.has_promo"
    />
    <input
      type="hidden"
      name="promo_start"
      :value="computedCoursePrice.promo_start"
    />
    <input
      type="hidden"
      name="promo_end"
      :value="computedCoursePrice.promo_end"
    />
    <input
      type="hidden"
      name="promo_limit"
      :value="computedCoursePrice.promo_limit"
    />
    <input
      type="hidden"
      name="multiple_licences"
      :value="computedCoursePrice.multiple_licences"
    />
    <input
      type="hidden"
      name="price_list"
      :value="computedCoursePrice.price_list"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import InputErrors from './form/InputErrors'
import _ from 'lodash'

const today = dayjs().format('YYYY-MM-DD')
const baseCourseData = {
  is_free: false,
  requires_login: false,
  price: 9900,
  promo_price: 5000,
  promo_start: today,
  promo_end: dayjs().add(7, 'days').format('YYYY-MM-DD'),
  promo_limit: -1,
  has_promo: false,
  multiple_licences: false,
  price_list: [],
}

export default {
  components: {
    InputErrors,
  },
  props: ['courseData', 'old', 'errors'],
  data() {
    return {
      course: this.formatCourseData(),
      today: today
    }
  },
  mounted() {},
  methods: {
    addNewPriceItem() {
      this.course.price_list = [
        ...this.course.price_list,
        {
        id: this.course.price_list.length + 1,
        activatesAfter: this.course.price_list.length + 1,
        value: 100,
        },
      ]
    },
    formatCourseData() {
      let data = {
        ...baseCourseData,
        ...this.courseData,
        ...this.old,
      }
      data.price_list = JSON.parse(data.price_list)
      data.price_list = data.price_list.map(el => {
        el.value = el.value / 100
        return el
      })
      data.price = this.priceValidation(data.price) / 10000
      data.promo_price =
        this.priceValidation(data.promo_price ? data.promo_price : 50000) / 10000

      data.promo_start = dayjs(data.promo_start).format('YYYY-MM-DD')
      data.promo_end = dayjs(data.promo_end).format('YYYY-MM-DD')

      data.is_free = this.castToBoolean(data.is_free)
      data.requires_login = this.castToBoolean(data.requires_login)
      data.has_promo = this.castToBoolean(data.has_promo)

      return data
    },
    castToBoolean(value) {
      if (value === 'true' || value === '1' || value === 1 || value === true) {
        return 1
      } else if (
        value === 'false' ||
        value === '0' ||
        value === 0 ||
        value === false
      ) {
        return 0
      }

      return 0
    },
    dateConflict(start, end) {
      return dayjs(end).diff(start, 'days') > 0 ? false : true
    },
    promoLimitValidation(value) {
      if (value === '' || value == null) {
        return -1
      }
      let number = parseInt(value)
      if (number < -1) {
        return -1
      }
      return number
    },
    priceValidation(value) {
      let price = parseInt(value) * 100

      if (price > 499) {
        return price
      }

      return 500
    },
    dateVlidation(value) {
      if (value === 'Invalid date') {
        return null
      }
      return value
    },
  },
  computed: {
    computedCoursePrice() {
      return {
        is_free: this.castToBoolean(this.course.is_free),
        requires_login: this.castToBoolean(this.course.requires_login),
        price: this.priceValidation(this.course.price),
        has_promo: this.castToBoolean(this.course.has_promo),
        multiple_licences: this.castToBoolean(this.course.multiple_licences),
        price_list: JSON.stringify([...this.course.price_list].map(el => {
          return el
        })),
        promo_price: this.priceValidation(this.course.promo_price),
        promo_start: this.dateVlidation(this.course.promo_start),
        promo_end: this.dateVlidation(this.course.promo_end),
        promo_limit: this.promoLimitValidation(this.course.promo_limit),
      }
    },
  },
}
</script>
